import audiConfirmation from '../../media/audi-confirmation.webp';
import audiLogo from '../../media/audi-logo.svg';

const CAR_MODEL_ID = 63;
// Configuration spécifique Audi
export const audiConfig = {
  // Configuration de l'application
  app: {
    carModelId: CAR_MODEL_ID,
    maxCommentLength: 200,
    sessionStorageKey: 'rdv_live',
    maxWorkingDaysAhead: 10,
  },

  // API Endpoints
  api: {
    calendar: `/calendar_for_business_center/${CAR_MODEL_ID}`,
    saveAppointment: 'save_appointment_for_business_center/',
  },

  // Url externes
  urlExternes: {
    rgpd: 'https://www.audi.fr/fr/tools/navigation/layer/mentions/',
  },

  // Messages
  messages: {
    loading: 'Chargement des disponibilités...',
    loadingAvailabilities: 'Chargement des disponibilités...',
    errorLoading: 'Erreur lors du chargement des données',
    errorAppointment:
      'Nous rencontrons actuellement un problème lors de la prise de votre rendez-vous. Nous vous prions de bien vouloir réessayer ultérieurement. Nous nous excusons pour ce désagrément.',
    errorTicketNotFound: 'Rendez-vous créé, mais ticket introuvable',
    errorDataLoading: 'Impossible de charger les données.',
    errorZendeskIdMissing:
      "Impossible d'enregistrer votre rendez-vous,  merci de prendre contact avec votre conseiller automobile.",
    errorCommentInvalid:
      'Erreur : Le commentaire contient des caractères non autorisés. Veuillez modifier votre message.',
    confirmationTitle: 'Merci de votre confiance !',
    confirmationSubtitle: 'Votre rendez-vous est confirmé',
    returnToMenu: 'Retour au menu',
    returnToMainMenu: 'Revenir au menu principal',
    retry: 'Réessayer',
    dateLabel: 'Date',
    mainTitle: 'Réservez votre rendez-vous téléphonique avec un conseiller connecté',
    timeSelectionTitle: 'Sélectionnez un créneau horaire',
    commentPlaceholder:
      'Ajoutez un commentaire à transmettre à votre conseiller',
    confirmButton: 'Confirmer ma réservation',
    breadcrumbDate: 'Date',
    breadcrumbSlot: 'Créneau',
    breadcrumbSeparator: ' > ',
    rgpdText:
      'Pour en savoir plus sur la gestion de vos données personnelles et pour connaître vos droits et les exercer, reportez-vous à la ',
    rgpdLinkText: 'Charte des Données Personnelles',
    testConfirmation: 'Tester la confirmation',
    resetToToday: "Réinitialiser à aujourd'hui",
    dateSimulator: 'Simulateur de date',
  },

  // Images
  images: {
    logo: audiLogo,
    confirmation: audiConfirmation,
  },

  // Design - Palette de couleurs complète pour Audi
  design: {
    name: 'Audi',
    logo: audiLogo,
    fontFamily: 'Audi',

    // Poids de la police par type de texte
    fontWeight: {
      title: '400', // Titre principal (bold)
      subtitle: '600', // Sous-titre (semi-bold)
      body: '400', // Texte normal
      button: '500', // Boutons (medium)
      label: '500', // Labels (medium)
      caption: '400', // Texte secondaire
      calendarDay: '500', // Jours du calendrier (medium)
      timeSlot: '500', // Créneaux horaires (medium)
      timeSlotSelected: '400', // Créneaux horaires sélectionnés (black)
      calendarDate: '900', // Date du calendrier (semi-bold)
    },

    // Taille de la police par type de texte
    fontSize: {
      title: '24px', // Titre principal
      subtitle: '18px', // Sous-titre
      body: '16px', // Texte normal
      button: '16px', // Boutons
      label: '14px', // Labels
      caption: '12px', // Texte secondaire
      calendarDay: '16px', // Jours du calendrier
      timeSlot: '16px', // Créneaux horaires
    },

    // Couleurs principales
    primaryColor: '#000000', // Noir Audi
    secondaryColor: '#ffffff', // Blanc
    accentColor: '#f5d11f', // Jaune Audi

    // Couleurs de texte
    textPrimary: '#000000', // Texte principal
    textSecondary: '#ffffff', // Texte secondaire
    textRgpdColor: '#707070', // Texte RGPD
    textDisabled: '#b3b3b3', // Texte désactivé
    textPlaceholder: '#b3b3b3', // Texte placeholder

    // Couleurs de fond
    backgroundPrimary: '#ffffff', // Fond principal
    backgroundSecondary: '#f5f5f5', // Fond secondaire
    backgroundHover: '#f0f0f0', // Fond au survol
    backgroundSelected: '#000000', // Fond sélectionné

    // Couleurs des bordures
    borderPrimary: '#ffffff', // Bordure principale
    borderSecondary: '#cccccc', // Bordure secondaire
    borderFocus: '', // Bordure focus

    // Couleurs d'état
    successColor: '#28a745', // Vert succès
    errorColor: '#dc3545', // Rouge erreur
    warningColor: '#ffc107', // Jaune avertissement
    infoColor: '#17a2b8', // Bleu info

    // Couleurs des boutons
    buttonPrimary: '#000000', // Bouton principal
    buttonPrimaryHover: '#333333', // Bouton principal survol
    buttonSecondary: '#ffffff', // Bouton secondaire
    buttonSecondaryHover: '#f5f5f5', // Bouton secondaire survol
    buttonDisabled: '#cccccc', // Bouton désactivé

    // Rayon des bordures des boutons
    buttonBorderRadius: '0px', // Rayon des bordures des boutons
    calendarDayBorderRadius: '0px', // Rayon des bordures des jours du calendrier
    timeSlotBorderRadius: '0px', // Rayon des bordures des créneaux horaires

    // Couleurs du calendrier
    calendarHeader: '#666666', // En-tête calendrier
    calendarDay: '#000000', // Jour calendrier
    calendarDayHover: '#000', // Jour calendrier survol
    calendarDaySelected: '#000000', // Jour sélectionné
    calendarDayDisabled: '#b3b3b3', // Jour désactivé

    // Couleurs des créneaux horaires
    timeSlot: '#ffffff', // Créneau horaire
    timeSlotHover: '#000', // Créneau survol
    timeSlotSelected: '#000000', // Créneau sélectionné
    timeSlotDisabled: '#b3b3b3', // Créneau désactivé
    timeSlotTextDisabled: '#838383', // Texte créneau désactivé
  },

  // Configuration des slugs
  slugs: {
    audiFiscale: 'audi-bc',
  },

  // Configuration des marques RDV
  marqueRdv: {
    bc: 'marquerdv_audibc',
  },

  // Données de test
  testData: {
    confirmationDate: '18 / 09 / 2025',
    confirmationTime: '12 : 30',
  },
};
